import { render, staticRenderFns } from "./left-right-projects.vue?vue&type=template&id=6099ed22&scoped=true&"
import script from "./left-right-projects.vue?vue&type=script&lang=js&"
export * from "./left-right-projects.vue?vue&type=script&lang=js&"
import style0 from "./left-right-projects.vue?vue&type=style&index=0&id=6099ed22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6099ed22",
  null
  
)

component.options.__file = "left-right-projects.vue"
export default component.exports